import { render, staticRenderFns } from "./Kyc-data.vue?vue&type=template&id=9d26af3a&scoped=true&"
import script from "./Kyc-data.vue?vue&type=script&lang=js&"
export * from "./Kyc-data.vue?vue&type=script&lang=js&"
import style0 from "./Kyc-data.vue?vue&type=style&index=0&id=9d26af3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d26af3a",
  null
  
)

export default component.exports